import { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { formatDate, formatTime } from "../../../../../utilities/utils";
import Loader from "../../../../commons/Loader";
import Pagination from "../../../pagination";
import { professionalTable, tableMenuItems } from "../../adminData";
import GlobalTableDropDown from "../../GlobalTableDropDown";
import { Link } from "react-router-dom";
import SkeletonTable from "../../../../commons/Skeleton/SkeletonTable";
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const ProfessionalsTable = ({
  professionalData,
  getUpdateData,
  handleDropDownMenu,
}) => {
  const checkbox = useRef();
  const [checked, setChecked] = useState(false);
  const [selectedPeople, setSelectedPeople] = useState([]);
  const [showMenu, setShowMenu] = useState(null);
  const { data, meta } = professionalData ?? {};
  const { current_page, last_page, per_page } = meta ?? {};
  const navigate = useNavigate();

  useEffect(() => {
    window.addEventListener("click", handleWindowClick);
    return () => {
      window.removeEventListener("click", handleWindowClick);
    };
  }, []);

  const handleWindowClick = () => {
    setShowMenu(null);
  };

  const handleMenuItems = (userId, flag) => {
    if (!flag) {
      setShowMenu(userId.id);
    } else {
      setShowMenu(null);
    }
  };

  const handleProfessionalsNavigation = (user) => {
    navigate(`/admin-dashboard/users/${user.id}`, {
      state: {
        userInfo: user,
      },
    });
  };

  return (
    <>
      <div className="px-4 sm:px-6 lg:px-8 hidden md:block">
        {!data ? (
          <SkeletonTable col={6} />
        ) : (
          <div className="mt-8 flow-root">
            <div className="table-scroller -mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8 bg-white border border-[#EBEFF3] rounded-md p-5">
              <div className="inline-block min-w-full py-2 align-middle">
                <div className="relative">
                  <table className="min-w-full table-fixed divide-y divide-gray-300">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          className="min-w-[12rem] px-3 py-4 text-left text-sm font-bold text-[#485868] lg:w-12"
                        >
                          # ID
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                        >
                          Name
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                        >
                          Email
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                        >
                          Address
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                        >
                          Status
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                        >
                          Created at
                        </th>
                        <th
                          scope="col"
                          className="relative py-3.5 pl-3 pr-4 sm:pr-0"
                        >
                          <span className="sr-only"></span>
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                      {data &&
                        data.length > 0 &&
                        data.map((professional, index) => (
                          <tr
                            key={professional.email}
                            className={` cursor-pointer hover:bg-[#EBF7FF]
                              ${
                                selectedPeople.includes(professional)
                                  ? "bg-gray-50"
                                  : undefined
                              }
                            `}
                          >
                            <Link
                              to={`/admin-dashboard/users/${professional.id}`}
                              state={{ userInfo: professional }}
                              className="contents"
                            >
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray lg:w-12">
                                {professional.id}
                              </td>
                              <td
                                className={classNames(
                                  "whitespace-nowrap py-4 pr-3 text-sm font-normal",
                                  selectedPeople.includes(professional)
                                    ? "text-primary"
                                    : "text-customGray"
                                )}
                              >
                                {professional.first_name.concat(
                                  " ",
                                  professional.last_name ?? ""
                                ) ?? "---"}
                              </td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                                {professional.email}
                              </td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                                {professional.office_address_1}
                              </td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                                <span
                                  className={`inline-flex items-center text-white capitalize rounded-md px-[10px] py-1 text-xs font-bold leading-[160%]`}
                                  style={{
                                    backgroundColor:
                                      professional?.status?.color,
                                  }}
                                >
                                  {professional?.status?.name ?? "---"}
                                </span>
                              </td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                                {formatDate(professional.created_at)} &#8226;{" "}
                                {formatTime(professional.created_at)}
                              </td>
                              <td>
                                 {/* <EllipsisVerticalIcon className="w-[18px] h-[18px] cursor-pointer" />  */}
                                <GlobalTableDropDown
                                  data={professional}
                                  showMenu={showMenu === professional.id}
                                  callBack={handleMenuItems}
                                  isLastIndex={index == data.length - 2}
                                  menuItems={tableMenuItems}
                                  handleDropDownMenu={handleDropDownMenu}
                                />
                              </td>
                            </Link>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                  {data?.length < 1 && (
                    <h4 className="flex items-center justify-center mt-5 text-lg text-primary py-6 font-bold">
                      No Record Found.
                    </h4>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="block md:hidden">
      {!data ? (
          <SkeletonTable col={6} />
        ) : (<div>
          <ul>
            {data &&
              data.slice(0, 5).map((professional, index) => (
                <li
                  className="border border-solid border-[#EBEFF3] rounded-md p-5 mb-[14px] flex justify-between bg-[#ffffff]"
                  onClick={() => handleProfessionalsNavigation(professional)}
                >
                  <ul>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        # ID
                      </h6>
                      <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                        {professional.id}
                      </span>
                    </li>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        Name
                      </h6>
                      <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                        {professional.first_name.concat(
                          " ",
                          professional.last_name ?? ""
                        ) ?? "---"}
                      </span>
                    </li>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        Email
                      </h6>
                      <span
                        className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px] max-w-[calc(100%-110px)]"
                        style={{ lineBreak: "anywhere" }}
                      >
                        {professional?.email}
                      </span>
                    </li>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        Address
                      </h6>
                      <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                        {professional?.office_address_1}
                      </span>
                    </li>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        Status
                      </h6>
                      <span
                        className={`inline-flex items-center text-white capitalize rounded-md px-[10px] py-1 text-xs font-bold leading-[160%]`}
                        style={{ backgroundColor: professional?.status?.color }}
                      >
                        {professional?.status?.name}
                      </span>
                    </li>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        Created At
                      </h6>
                      <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                        {formatDate(professional.created_at)} &#8226;{" "}
                        {formatTime(professional.created_at)}
                      </span>
                    </li>
                  </ul>
                  <div>
                    <GlobalTableDropDown
                      data={professional}
                      showMenu={showMenu === professional.id}
                      callBack={handleMenuItems}
                      isLastIndex={index == professionalTable.length - 2}
                      menuItems={tableMenuItems}
                      handleDropDownMenu={handleDropDownMenu}
                    />
                  </div>
                </li>
              ))}
          </ul>
          {data?.length < 1 && (
            <h4 className="flex items-center justify-center mt-5 text-lg text-primary py-6 font-bold">
              No Record Found.
            </h4>
          )}
        </div>)}
      </div>
      {data?.length > 0 && (
        <Pagination
          currentPage={current_page}
          totalPages={last_page}
          nextPage={getUpdateData}
          previousPage={getUpdateData}
          directIntoPage={getUpdateData}
          perPageItem={per_page}
          showNumberOfPages={3}
          meta={meta}
        />
      )}
    </>
  );
};

export default ProfessionalsTable;
